import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AdalService } from '../service';

@Injectable()
export class OAuthCallbackHandler implements CanActivate {
	constructor(private router: Router, private adalService: AdalService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		this.adalService.handleCallback();
		if (this.adalService.userInfo) {
			localStorage.setItem('token', this.adalService.accessToken);
			const returnUrl = route.queryParams['returnUrl'];
			if (!returnUrl) {
				this.router.navigate(['login']);
			} else {
				this.router.navigate([returnUrl], { queryParams: route.queryParams });
			}
		}
		return false;
	}
}
